module.exports = __webpack_public_path__ + "img/icon-new-window.db57f725.svg";